document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    //Reviews
    const wrapper = document.querySelector('.jobolon-reviews-wrapper');
    const item = document.querySelector('.jobolon-review-item');

    if (wrapper && item) {
        document.getElementById('nextReview').addEventListener('click', () => {
            wrapper.scrollLeft += getScrollAmount();
        });

        document.getElementById('prevReview').addEventListener('click', () => {
            wrapper.scrollLeft -= getScrollAmount();
        });
    }

    function getScrollAmount() {
        // Обновляем ширину на каждое нажатие
        return item.offsetWidth + parseInt(getComputedStyle(item).marginRight);
    }


    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);

        // Close menu when clicking on links
        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });

        // Close menu when clicking outside its area
        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }
});


jQuery(document).ready(function ($) {
    $('#jobolon-contact-form').on('submit', function (e) {
        e.preventDefault();
        $('#jobolon-popup-thank-you').fadeIn(300);

        setTimeout(function () {
            $('#jobolon-popup-thank-you').fadeOut(300);
        }, 3000);

        $('#jobolon-contact-form')[0].reset();
    });
});